import React from 'react';
import { FaCalendarTimes } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import { FaFlag, FaCheckCircle, FaClock, FaTimesCircle } from 'react-icons/fa';
import './layout.css';

const LeaveLayout = ({ children }) => {
  return (
    <div >
      <h1 className="leave-policy-title"style={{marginTop:'30px'}}>
        <FaCalendarTimes className="leave-policy-icon" />
        Leave Information
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="leave-policy-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/my-leave-policy"
              >
                <FaFlag className="nav-icon" /> My Leave Policy
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="my-approved-leave-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/my-approved-leave"
              >
                <FaCheckCircle className="nav-icon" /> Approved Leave
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="my-pending-leave-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/my-pending-leave"
              >
                <FaClock className="nav-icon" /> Pending Leave
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="my-rejected-leave-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/my-rejected-leave"
              >
                <FaTimesCircle className="nav-icon" /> Rejected Leave
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="Leaves-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/My-Leaves"
              >
                <FaCheckCircle className="nav-icon" /> Leaves
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="content">
          {children} {/* Render the child components here */}
        </div>
      </section>
    </div>
  );
};

export default LeaveLayout;
